import { AbstractControl, ValidationErrors } from '@angular/forms';

export function fabrikatValidator(formGroup: AbstractControl): ValidationErrors {
  if (!formGroup.get('fabrikatId') || !formGroup.get('unknownFabrikat') || !formGroup.get('alternativFabrikat')) {
    return null;
  }

  const fabrikatId = formGroup.get('fabrikatId').value;
  const unknownFabrikat = formGroup.get('unknownFabrikat').value;
  const alternativFabrikat = formGroup.get('alternativFabrikat').value;

  if (!fabrikatId && !alternativFabrikat && unknownFabrikat == false) {
    return { fabrikatId: 'Fabrikat skal angives.' };
  }

  return null;
}
